/**
 * Makes sure that we have a slash after the param we pass to it
 * @param url
 * @returns
 */
export const trailingSlash = url => {
  return url.replace(/\/?$/, "/");
};
